import { render } from "./business-info.vue?vue&type=template&id=6dc4b07d&scoped=true"
import script from "./business-info.vue?vue&type=script&lang=js"
export * from "./business-info.vue?vue&type=script&lang=js"

import "./business-info.vue?vue&type=style&index=0&id=6dc4b07d&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc4b07d"]])

export default __exports__